import store from '@/store'
import axios from 'axios'

export default {

  async getProductsIndex () {
    try {
      let r = await axios.get(store.getters.getProductsIndexApi + '/' + store.getters.getCompany.companyId + '/name_index/index.json?t=' + new Date().getTime())
      if (r.data) {
        return r.data
      } else {
        return {error:true}
      }
    } catch (e) {
      console.log(e)
      return {error: true}
    }
  },

  async getAllProducts () {
    try {
      let result = await axios.get(store.getters.getProductApi + '/products?company_id=' + store.state.company.companyId)
      if (!result.data) {
        return {error: true}
      }
      store.state.cachedProducts = result.data
      return result.data
    } catch(e) {
      let error = {e}
      return {error: true, data: error}
    }
  },

  async getProductsByListId (listId) {
    try {
      console.log(listId)
      let products = await axios.get(store.getters.getProductApi + '/product-list/' + listId)
      if (products.data) {
        return products.data
      } else {
        console.log(products)
        return {error:true}
      }
    } catch (e) {
      let error = {e}
      return {error: true, data: error}
    }
  },

  async getProductsByIds (ids) {
    try {
      let products = await axios.get(store.getters.getProductApi + '/products/batch?ids=' + JSON.stringify(ids))
      if (products.data) {
        return products.data
      } else {
        console.log(products)
        return {error:true}
      }
    } catch (e) {
      let error = {e}
      return {error: true, data: error}
    }
  },

  async getProductNameById (id) {
    if (!store.state.cachedProducts) {
      await this.getAllProducts()
    }
    let names = store.state.cachedProducts.filter(p => p.id === id)
    console.log('p name', names)
    if(names.length) {
      return names[0].name
    } else {
      return ''
    }
  },

  async patchPresentations (presentations, productId) {
    try {
      let result = await axios.patch(store.getters.getProductApi + '/products/' + productId + '/presentations', presentations)
      if (!result.data) {
        return {error: true, msg:'error ao salvar apresentações'}
      } else {
        return result.data
      }
    } catch(e) {
      console.log(e)
      return {error: true, msg:'error ao salvar apresentações'}
    }

  }




}
